import createAction from 'redux-actions/lib/createAction';
import webp from 'check-for-webp';

export const WEBP_SUPPORT = 'registrationActions/WEBP_SUPPORT';

export const hasWebpSupport = createAction(WEBP_SUPPORT, () => ({ hasWebpSupport: webp }));
